module.exports = __webpack_public_path__ + "static/media/steve-dengler.048ff974.jpg";